export default __webpack_public_path__ + "static/media/log-icon.0b2a8ec2.svg";